<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar
          dense
          :dark="$vuetify.theme.dark"
          :color="'primary'">
        <v-toolbar-title>
          {{ $t('Изменение даты окончания полномочий') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-progress-linear v-if="isLoading" color="loader" indeterminate />
      <v-card-text class="pa-3">
        <ValidationObserver ref="expirationDateForm" tag="v-card-text">

          <validatable-date-picker
              v-model="expirationDate"
              v-test="{ date: 'expirationDate' }"
              rules="required"
              :label="$t('Дата окончания полномочий Единоличного исполнительного органа')" />

        </ValidationObserver>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="saveBtn"
            v-test="{ btn: 'save' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="updateExpirationDate">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import ValidatableDatePicker from '@/components/reused/ui/ValidatableDatePicker.vue'
  import { mapActions, mapState } from 'vuex'
  import { USER_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      ValidatableDatePicker
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => ({
          show: false,
          userId: null,
          callback: () => {}
        })
      }
    },
    data () {
      return {
        isLoading: false,
        expirationDate: null
      }
    },
    computed: {
      ...mapState(USER_MANAGEMENT.NAMESPACE, {
        expirationDates: state => (state[USER_MANAGEMENT.STATE.USER_EXPIRATION_DATES] || {})
      })
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        vm.getExpirationDates()
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(USER_MANAGEMENT.NAMESPACE, {
        getExpirationDatesAction: USER_MANAGEMENT.ACTIONS.GET_EXPIRATION_DATES,
        updateExpirationDateAction: USER_MANAGEMENT.ACTIONS.UPDATE_EXPIRATION_DATE,
        clearExpirationDatesAction: USER_MANAGEMENT.ACTIONS.CLEAR_EXPIRATION_DATES
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearExpirationDatesAction()
          ])
      },
      getExpirationDates: async function () {
        try {
          this.isLoading = true
          await this.getExpirationDatesAction(this.dialogProp.userId)
          this.isLoading = false
          this.expirationDate = this.expirationDates.documentExpirationDate
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      updateExpirationDate: async function () {
        const result = await this.$refs.expirationDateForm.validate()
        if (!result) {
          return
        }
        try {
          this.isLoading = true
          await this.updateExpirationDateAction({
            userId: this.dialogProp.userId,
            expirationDate: this.expirationDate
          })
          this.isLoading = false
          if (this.dialogProp.callback) {
            this.dialogProp.callback()
          }
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
